import { FRONTIFY_URL } from '@shared/utils';

const FALLBACK_OFFER_IMAGE = `${FRONTIFY_URL}znuSNYA3k8N8xYg3GViz.png`;

export { FALLBACK_OFFER_IMAGE };
